
import Buliding from "../../../assets/duotone/Buliding.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BulidingIcon({ className, dataTestid = "BulidingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Buliding data-testid={dataTestid} className={classes} {...rest} />
  );
}
